import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";
import WhereUsedState from "@dana/Store/Data/ProductRelations/WhereUsedState";

const initialState: WhereUsedState = {
    productId: "",
    parts: [],
    pagination: {} as PaginationModel,
    relation: "WTU",
    isLoading: false
};

const whereUsedStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "BeginLoadWhereUsedProducts": (draft: Draft<WhereUsedState>, action: { isLoading: boolean }) => {
        draft = { ...initialState, isLoading: true };

        return draft;
    },
    "CompleteLoadWhereUsedProducts": (draft: Draft<WhereUsedState>, action: { productId: string, products: ProductModel[], pagination: PaginationModel }) => {
        draft = {
            ...initialState,
            isLoading: false,
            productId: action?.productId,
            parts: action?.products,
            pagination: action?.pagination,
        };
        return draft;
    },
    "FailedLoadWhereUsedProducts": (draft: Draft<WhereUsedState>, action: { products: ProductModel[], total: number }) => {
        draft = { ...initialState, isLoading: false };
        return draft;
    }
});

(reducers as any).whereUsedState = whereUsedStateImmerReducer;

type WhereUsedReducers = {
    whereUsedState: typeof whereUsedStateImmerReducer;
};

export type WhereUsedActions = Parameters<WhereUsedReducers[keyof WhereUsedReducers]>[1] | AnyAction;

